import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';

import { ErrorMessage } from 'src/components/ErrorMessage';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      minHeight: 1,
      marginBottom: 20,
    },
  }),
);
/**
 * This component is used to wrap the error callout
 * with a fixed height to avoid the form jumping.
 * @returns {JSX.Element} Returns the error callout
 */
export const OnboardingFormError: React.FC<{
  errorText: string;
}> = ({ errorText }) => {
  const classNames = useStyles();
  return (
    <div className={classNames.root}>
      {errorText && <ErrorMessage message={errorText} />}
    </div>
  );
};
